import React from 'react';
import { Card, Modal } from 'react-bootstrap';
import { SingleAdminLevelI } from '../../../types/interface';
import { t } from 'i18next';
import { getCookie } from 'utils/cookieUtils';
import { ENGLISH, SELECTED_LANGUAGE } from 'utils/enums/misc';

interface ViewAdminLevelModalProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  data: SingleAdminLevelI | undefined;
}

const ViewAdminLevelModal = (props: ViewAdminLevelModalProps) => {
  const currentLanguage = getCookie(SELECTED_LANGUAGE)
  return (
    <Modal show={props.show} onHide={() => props.setShow(false)} size="lg">
      <Modal.Header closeButton>
       <h3>{currentLanguage === ENGLISH ? props.data?.level_name : props.data?.level_name_de} ({t('admin_level.table.column_3')}: {props.data?.level_order})</h3>
        </Modal.Header>
      <Modal.Body>
        <div className="container">
          <Card>
            <Card.Header>
              <h4>
                {props.data?.assigned_user_count} {t('general.text_15')}
              </h4>
            </Card.Header>
            <Card.Body>
              <div className="row g-0">
                {props.data?.assigned_users?.map((user, index) => (
                  <div
                    className="col-4 p-2 ps-0"
                    key={`single-admin-level-${index}`}
                  >
                    <div className=" bg-body-secondary rounded-5 py-2 ps-2 fw-semibold">
                      {user.first_name} {user.last_name}
                    </div>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewAdminLevelModal;
